// extracted by mini-css-extract-plugin
export var useful = "useful-module--useful--91ef0";
export var useful__item = "useful-module--useful__item--3b51b";
export var useful__itemImg = "useful-module--useful__item-img--87625";
export var useful__itemText = "useful-module--useful__item-text--69dea";
export var useful__list = "useful-module--useful__list--01452";
export var useful__mainImg = "useful-module--useful__main-img--39a2a";
export var useful__mainText = "useful-module--useful__main-text--01dfc";
export var useful__mainThoughts = "useful-module--useful__main-thoughts--a5fa7";
export var useful__text = "useful-module--useful__text--2f4ef";
export var useful__title = "useful-module--useful__title--9d74d";
export var useful__wrapper = "useful-module--useful__wrapper--7af7b";